import { createStyles } from "antd-style";

export const useModalCaseCancelStyles = createStyles(({ css }) => ({
  modal: css``,
}));
